import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button } from '@mui/material';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

export const SUBMIT_SHORTCUT_LABEL = isMac ? '⌘ + Enter' : 'Ctrl + Enter';

export const isSubmitShortcut = (e: React.KeyboardEvent) => e.key === 'Enter' && (e.metaKey || e.ctrlKey);

/** Shown in place of AI controls when the account has no active plan; the form still works. */
export const PlansNotice: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Alert
    severity="info"
    variant="outlined"
    action={
      <Button component={RouterLink} to="/dashboard/subscription" size="small" color="inherit">
        View plans
      </Button>
    }
  >
    {children}
  </Alert>
);
